import { request } from '@/api/client'

export function runMasterAutopilot() {
  return request('/master/autopilot/run', { method: 'POST' })
}

export function sendMasterDigest() {
  return request('/master/notifications/run-digest', {
    method: 'POST',
    body: {},
  })
}
